export interface Cookie {
  key: string;
  value: string;
}

export const DARK_THEME_COOKIE_KEY = 'flease-dark-theme';

export class CookieService {
  static getAll(): Cookie[] {
    return document.cookie.split(';').map((cookieString) => {
      const cookieParts = cookieString.trim().split('=');
      return { key: cookieParts[0], value: cookieParts[1] };
    });
  }

  static clear(filter: (cookie: Cookie) => boolean = () => true) {
    this.getAll()
      .filter(filter)
      .forEach(({ key, value }) => {
        document.cookie = `${key}=${value}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
  }

  static get(name: string) {
    const matchingCookies = this.getAll().filter((cookie) => cookie.key === name);
    return matchingCookies.length ? matchingCookies[0].value : undefined;
  }

  static set(name: string, value: string, secondToLeave = 365 * 24 * 60 * 60) {
    document.cookie = `${name}=${value};expires=${this.getExpirationDate(
      secondToLeave
    )};path=/;SameSite=Strict`;
  }

  private static getExpirationDate(ttlInSecond: number): string {
    return new Date(new Date().getTime() + ttlInSecond * 1000).toUTCString();
  }
}
